export default "__VITE_ASSET__Cu7Fy2HA__"